import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  getChuteConfigs,
  postChuteConfigs,
  putChuteConfigs,
  deleteChuteConfigs,
  getChuteByIdTemplate,
  postChuteByIdTemplate,
  getChuteConfigsById,
  postChuteConfigsById,
  putChuteConfigsById,
  deleteChuteConfigsById,
  deleteChuteConfigsByIdV2,
  deleteChuteConfigsBulkById,
  downloadChuteById,
  getAgentConfigs,
  getMachineScans,
  getSortingConfig,
  exportMachineScans,
  receiveMachineScan,
  outScanMachineScan,
  postAgentConfigs,
  putAgentConfigs,
  deleteAgentConfigs,
  deactivateAgentConfigs,
  getShipmentTypes,
  downloadAgents
} from "../../services/SortingMachine/SortingServices";
const initialValues = {
  shipmentTypes: [],
};
let sortingStore = (set) => ({
  ...initialValues,
  getChuteConfigs: async (params) => {
    const response = await getChuteConfigs(params);
    return response;
  },
  getChuteConfigsById: async (params,data) => {
   const response = await getChuteConfigsById(params,data);
   return response;
 },
 postChuteConfigs: async (params) => {
   const response = await postChuteConfigs(params);
   return response;
 },
 putChuteConfigs: async (params,data) => {
   const response = await putChuteConfigs(params,data);
   return response;
 },
 deleteChuteConfigs: async (params) => {
   const response = await deleteChuteConfigs(params);
   return response;
 },
 getChuteByIdTemplate: async () => {
   const response = await getChuteByIdTemplate();
   return response;
 },
 postChuteByIdTemplate: async (params,data) => {
   const response = await postChuteByIdTemplate(params,data);
   return response;
 },
 postChuteConfigsById: async (params,data) => {
   const response = await postChuteConfigsById(params,data);
   return response;
 },
 putChuteConfigsById: async (params,data) => {
   const response = await putChuteConfigsById(params,data);
   return response;
 },
 deleteChuteConfigsById: async (params,data) => {
   const response = await deleteChuteConfigsById(params,data);
   return response;
 },
 deleteChuteConfigsByIdV2: async (params) => {
   const response = await deleteChuteConfigsByIdV2(params);
   return response;
 },
 deleteChuteConfigsBulkById: async (params,data) => {
   const response = await deleteChuteConfigsBulkById(params,data);
   return response;
 },
 downloadChuteById: async (params) => {
   const response = await downloadChuteById(params);
   return response;
 },
 getAgentConfigs: async (params) => {
   const response = await getAgentConfigs(params);
   return response;
 },
 getMachineScans: async (params) => {
   const response = await getMachineScans(params);
   return response;
 },
 getSortingConfig: async (params) => {
   const response = await getSortingConfig(params);
   return response;
 },
 exportMachineScans: async (params) => {
   const response = await exportMachineScans(params);
   return response;
 },
 receiveMachineScan: async (params) => {
   const response = await receiveMachineScan(params);
   return response;
 },
 outScanMachineScan: async (params) => {
   const response = await outScanMachineScan(params);
   return response;
 },
 postAgentConfigs: async (params) => {
   const response = await postAgentConfigs(params);
   return response;
 },
 putAgentConfigs: async (params,data) => {
   const response = await putAgentConfigs(params,data);
   return response;
 },
 deleteAgentConfigs: async (params) => {
   const response = await deleteAgentConfigs(params);
   return response;
 },
 deactivateAgentConfigs: async (params,data) => {
   const response = await deactivateAgentConfigs(params,data);
   return response;
 },
 downloadAgents: async (params) => {
   const response = await downloadAgents(params);
   return response;
 },
  getShipmentTypes: async (params) => {
   const response = await getShipmentTypes(params);
   set({ shipmentTypes: response?.data?.data });
   return response;
 },
});

sortingStore = devtools(sortingStore);

export const useSortingStore = create(sortingStore);
